import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash'; // import cx from 'classnames'

import i18n from 'i18next';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import $ from 'jquery';
import Progress from './ui/react-ui/progress.jsx';
import TrafficEventMap from './trafficDashboard/trafficEvent-map';
import TrafficEventTable from './trafficDashboard/trafficEvent-table';
import TrafficEventDialog from './trafficDashboard/trafficEvent-dialog'; // api

import { getEventTrafficGeographic } from '../api/deviceAPI';
import { getTrafficEventListPublished } from '../api/eventAPI';
import { getTrafficEventTypeList } from '../api/eventAPI'; //

import { setTrafficEventMarkers, setTrafficEventTableData, setEventTypeList, reset } from '../redux/traffic-dashboard';
var t = i18n.getFixedT(null, 'traffic-dashboard');
var TrafficDashboard = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      isMobileDevice = _useSelector.app.isMobileDevice,
      _useSelector$trafficD = _useSelector.trafficDashboard,
      mapBounds = _useSelector$trafficD.mapBounds,
      trafficEventMarkersSort = _useSelector$trafficD.trafficEventMarkersSort;

  var dispatch = useDispatch();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showEventTable = _useState2[0],
      setShowEventTable = _useState2[1];

  var _isMounted = useRef();

  var id = props.id;
  useEffect(function () {
    if (_isMounted.current && !_.isEmpty(mapBounds)) {
      var latLngStart = mapBounds._southWest,
          latLngEnd = mapBounds._northEast;
      getEventTrafficGeographic(contextRoot, true, latLngStart, latLngEnd).then(function (result) {
        var newData = _.cloneDeep(result.content);

        newData.sort(function (a, b) {
          return moment(b.beginTime).valueOf() - moment(a.beginTime).valueOf();
        });

        _.map(newData, function (el, index) {
          el.sequence = index + 1;
        });

        dispatch(setTrafficEventMarkers(newData));
      });
    }
  }, [JSON.stringify(mapBounds)]);
  useEffect(function () {
    if (!_isMounted.current) {
      Progress.startSpin();
      var getEventListPublish_api = getTrafficEventListPublished(contextRoot, true, '', trafficEventMarkersSort, 0, null);
      var getEventType_api = getTrafficEventTypeList(contextRoot, true);
      $.when(getEventListPublish_api, getEventType_api).then(function (eventList_result, eventType_result) {
        var now = moment().valueOf();

        var eventData = _.filter(eventList_result.content, function (el) {
          if (_.isEmpty(el.endTime)) return true;
          var endTime = moment(el.endTime).valueOf();
          return endTime > now;
        });

        var events = _.map(eventData, function (el, index) {
          return _objectSpread(_objectSpread({}, el), {}, {
            sequence: index + 1
          });
        });

        dispatch(setTrafficEventTableData(events));

        var eventTypeList = _.map(eventType_result.content, function (el) {
          return {
            value: el.id,
            text: el.name
          };
        });

        dispatch(setEventTypeList(eventTypeList));
        Progress.done();
      });
      _isMounted.current = true;
    }

    return function () {
      dispatch(reset());
    };
  }, []);

  var handleShowEventTable = function handleShowEventTable() {
    setShowEventTable(!showEventTable);
  };

  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement(TrafficEventTable, {
    isShowEventTable: isMobileDevice ? showEventTable : true
  }), /*#__PURE__*/React.createElement(TrafficEventMap, null), /*#__PURE__*/React.createElement(TrafficEventDialog, null), isMobileDevice && /*#__PURE__*/React.createElement("div", {
    className: "event-icon-wrap",
    onClick: function onClick() {
      return handleShowEventTable();
    }
  }, showEventTable ? /*#__PURE__*/React.createElement("i", {
    className: "fas fa-times"
  }) : /*#__PURE__*/React.createElement("i", {
    className: "far fa-file-alt"
  })));
});
TrafficDashboard.defaultProps = {
  id: 'g-traffic-dashboard'
};
TrafficDashboard.PropTypes = {
  id: PropTypes.string
};
export default TrafficDashboard;